var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8379 0.838135C21.0935 0.838135 0.152344 21.7793 0.152344 47.5237C0.152344 57.7336 3.44592 67.2022 9.04468 74.8877L3.22593 92.2332L21.1756 86.4981C28.5583 91.3835 37.3685 94.21 46.865 94.21C72.6094 94.21 93.5506 73.268 93.5506 47.5244C93.5506 21.78 72.6094 0.83891 46.865 0.83891H46.8379V0.838135Z",
    fill: "url(#paint0_linear_804_8727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8005 24.5528C32.895 22.3847 32.2087 22.3026 30.8369 22.2468C30.316 22.2133 29.7942 22.1952 29.2722 22.1926C27.4876 22.1926 25.6216 22.7139 24.4961 23.8665C23.1243 25.2662 19.7207 28.5319 19.7207 35.2291C19.7207 41.9262 24.6061 48.4034 25.2645 49.3096C25.9508 50.2144 34.7889 64.1571 48.5116 69.8395C59.2428 74.2857 62.4272 73.8736 64.8695 73.3523C68.4373 72.5839 72.9113 69.9479 74.0368 66.7651C75.1623 63.5808 75.1623 60.8635 74.8323 60.2872C74.5031 59.7109 73.5969 59.3825 72.225 58.6954C70.8532 58.0091 64.1832 54.7155 62.9206 54.2763C61.6851 53.81 60.5054 53.975 59.5728 55.2926C58.2552 57.1315 56.9655 58.9983 55.9222 60.123C55.0988 61.0014 53.7533 61.1114 52.6286 60.6443C51.1189 60.0138 46.8927 58.5304 41.6774 53.8921C37.6425 50.2972 34.8981 45.824 34.1026 44.4793C33.3063 43.1075 34.0205 42.3104 34.651 41.5699C35.3373 40.7186 35.9957 40.1152 36.682 39.3189C37.3683 38.5234 37.7525 38.1113 38.1917 37.1779C38.6588 36.2724 38.3288 35.339 37.9996 34.6528C37.6704 33.9665 34.926 27.2693 33.8005 24.5528Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_804_8727",
    x1: -350.773,
    y1: -155.577,
    x2: -350.773,
    y2: -152.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EBF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#50A557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#2A904F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#50A557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBF63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBig);
export default __webpack_public_path__ + "static/media/WhatsappBig.ba2676dc4e543e5899e08bdd3a40b403.svg";
export { ForwardRef as ReactComponent };